import lightTheme from '@/components/ui/styles/light';
import darkTheme from '@/components/ui/styles/dark';

export default {
  lightTheme,
  darkTheme,
};
